import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { Municipality } from '@/types'

export async function readMunicipalities(state: string) {
  const response = await httpClient('accounting-dealer').get<Municipality[]>(
    '/v3/person/municipality',
    { params: { state_code: state } },
  )

  return response.data
}

export function useReadMunicipalities(state: string) {
  return useQuery({
    queryKey: ['municipalities', state],
    queryFn: () => readMunicipalities(state),
    enabled: Boolean(state),
  })
}
